import React, { PureComponent, Fragment } from 'react';
import Cookies from 'js-cookie';
import { Dialog, Icon } from '@tencent/spaui';

import { callDialogPrefix as prefix } from '../../../consts/prefix';

class CallTip extends PureComponent {
  constructor(props) {
    super(props);
    this.key = prefix + window.pageProps.uid;
    // 如果首次显示的时间跟现在比在三天内，就显示，否则不显示
    this.state = {
      showDialog: !Cookies.get(this.key) && !localStorage.getItem(this.key),
    };
  }

  setBannerDisplayed = () => {
    // 设置首次显示的时间，毫秒
    if (!Cookies.get(this.key) && !localStorage.getItem(this.key)) {
      localStorage.setItem(prefix + window.pageProps.uid, Date.now());
    }
  };

  onClose = () => {
    this.setState({
      showDialog: false,
    });
  };

  onCancel = () => {
    this.setState({
      showDialog: false,
    });
    this.setBannerDisplayed();
  };

  onComplete = () => {
    this.setBannerDisplayed();
  };

  render() {
    const jumpUrl = '#/system/leadsManageSetting/call';
    return (
      <Fragment>
        <Dialog
          backdrop
          type="normal"
          className="dialog-pay-banner"
          style={{ width: 410 }}
          cancelButton={null}
          submitLabel="我知道了"
          hideHeader
          footerStyle={{ textAlign: 'center', padding: 20 }}
          onSubmit={this.onCancel}
          show={this.state.showDialog}
          onClose={this.onClose}
        >
          <div className='self-header'>线索外呼提醒</div>
          <div className='step-content step0' style={{ color: '#FA8E00', lineHeight: '22px' }}>
            <Icon name='info-filled' color='#FA8E00' />
            <span>12月15日起，未报备话术将无法使用外呼功能，请管理员尽快在线索管理设置中报备话术。</span>
            {(window.pageProps.originRole === 'OPERATOR_ROLE_LEADS_MANAGER' || window.pageProps.originRole === 'OPERATOR_ROLE_LEADS_OBSERVER')
             && <a target="_blank" href={jumpUrl} rel="noreferrer" style={{ textDecorationLine: 'underline' }}>去设置</a>}
          </div>
          <div className='step-content step0' style={{ lineHeight: '22px' }}>为了提高接通率，建议未接通线索在48小时内进行5次拨打，<br />预计接通率可达80%以上，操作示例：</div>
          <div className="pay-content">
            <div className='step-title step1'>1. 在12小时内进行首次拨打（30分钟内最佳）</div>
            <div className='step-title step2'>2. 在24小时内进行第2、3次拨打</div>
            <div className='step-title step3'>3. 在48小时内进行第4、5 次拨打</div>
            <br />
            <div>平台会定期更换被标记的中间号；也支持通过右上角“反馈中心”反馈被标记的号码，平台核实后会及时下线和更新。</div>
          </div>
        </Dialog>
      </Fragment>
    );
  }
}

export default CallTip;
